export default __webpack_public_path__ + "1fcb6c5748b34058c7873f8dbfe3190c.svg";